import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bfe1c7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-left list-view-button" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-view-text" }, "List View", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Trailer Solutions")
], -1))
const _hoisted_6 = { class: "item-navigator-header-container" }
const _hoisted_7 = { class: "item-navigator-body-container" }
const _hoisted_8 = {
  key: 1,
  class: "w-100 h-100 location-content-container"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "navigation-swap d-flex flex-column justify-content-center" }
const _hoisted_11 = {
  key: 6,
  class: "proximity-check-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AttachTrailerConfirmation = _resolveComponent("AttachTrailerConfirmation")!
  const _component_ItemNavigator = _resolveComponent("ItemNavigator")!
  const _component_LocationContent = _resolveComponent("LocationContent")!
  const _component_fbx_button = _resolveComponent("fbx-button")!
  const _component_SidebarConfirmation = _resolveComponent("SidebarConfirmation")!
  const _component_ConfirmationOverlay = _resolveComponent("ConfirmationOverlay")!
  const _component_AlreadyHaveTrailerAttached = _resolveComponent("AlreadyHaveTrailerAttached")!
  const _component_DriverLoaded = _resolveComponent("DriverLoaded")!
  const _component_VerifyProximity = _resolveComponent("VerifyProximity")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showConfirm)
      ? (_openBlock(), _createBlock(_component_AttachTrailerConfirmation, {
          key: 0,
          trailerNumber: _ctx.trailerNumber,
          trailerCompany: _ctx.trailerCompany,
          onAccept: _ctx.routeToTrailerAssessment,
          onReject: _ctx.cancelConfirm
        }, null, 8, ["trailerNumber", "trailerCompany", "onAccept", "onReject"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "sidebar-header flex-row",
      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switchExpand && _ctx.switchExpand(...args)), ["stop"]))
    }, [
      _createElementVNode("div", {
        class: "flex-row",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToListView && _ctx.backToListView(...args)))
      }, _hoisted_4),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_ItemNavigator, {
          "current-index": _ctx.currentIndex,
          "total-items": _ctx.results.length,
          onCycleLeft: _ctx.cycleLeft,
          onCycleRight: _ctx.cycleRight
        }, null, 8, ["current-index", "total-items", "onCycleLeft", "onCycleRight"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_ItemNavigator, {
        "current-index": _ctx.currentIndex,
        "total-items": _ctx.results.length,
        onCycleLeft: _ctx.cycleLeft,
        onCycleRight: _ctx.cycleRight
      }, null, 8, ["current-index", "total-items", "onCycleLeft", "onCycleRight"])
    ]),
    (!_ctx.showConfirmNewNavigation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_LocationContent, {
            displayedResult: _ctx.displayedResult,
            locationTitle: _ctx.locationTitle,
            travelTime: _ctx.travelTime,
            onViewAvailableTrailers: _ctx.onDisplayCustomerTrailers
          }, null, 8, ["displayedResult", "locationTitle", "travelTime", "onViewAvailableTrailers"]),
          _createElementVNode("div", {
            class: _normalizeClass(["justify-content-center align-items-center button-container", {
                    'pad-bottom':
                        _ctx.isCustomerLocation || !_ctx.trailerAssociationsEnabled,
                }])
          }, [
            _createVNode(_component_fbx_button, {
              "button-text": 
                        _ctx.showLoading ? 'Getting Directions' : 'Get Directions'
                    ,
              class: _normalizeClass({
                        selecting: _ctx.didSelectNavDestination,
                        disabled: _ctx.isReserved,
                    }),
              theme: "primary",
              "show-loading": _ctx.showLoading,
              onClick: _withModifiers(_ctx.checkCargoSensorAndShowModal, ["prevent"])
            }, null, 8, ["button-text", "class", "show-loading", "onClick"]),
            (_ctx.trailerAssociationsEnabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (!_ctx.isCustomerLocation)
                    ? (_openBlock(), _createBlock(_component_fbx_button, {
                        key: 0,
                        "button-text": "I'm ready to attach now",
                        theme: "link",
                        class: "italic",
                        onClick: _withModifiers(_ctx.setupTrailerAttach, ["prevent"])
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]))
      : (_openBlock(), _createBlock(_component_SidebarConfirmation, {
          key: 2,
          acceptText: _ctx.showLoading ? 'Loading' : 'OK',
          rejectText: "Cancel",
          onAccept: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendNavigationTask(true))),
          onReject: _ctx.declineNavigationChange,
          confirmationLoading: _ctx.showLoading
        }, {
          "main-content": _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _createTextVNode(" By navigating to trailer "),
                _createElementVNode("b", null, "#" + _toDisplayString(_ctx.displayedResult?.trailers[0]?.trailerNumber), 1),
                _createTextVNode(", trailer "),
                _createElementVNode("b", null, "#" + _toDisplayString(_ctx.currentTrailerReservation?.trailerId?.split(
                                    '|'
                                )[0]), 1),
                _createTextVNode(" will no longer be held for you. ")
              ])
            ])
          ]),
          _: 1
        }, 8, ["acceptText", "onReject", "confirmationLoading"])),
    (_ctx.showCargoSensorIssueModal === true)
      ? (_openBlock(), _createBlock(_component_ConfirmationOverlay, {
          key: 3,
          acceptText: "Continue",
          "accept-theme": "primary",
          "reject-theme": "return",
          "full-screen": false,
          forceHideDeepLink: true,
          rejectText: "Find a Trailer Elsewhere",
          "title-text": `<b>Cargo Sensor Issue</b>`,
          "subheading-text": "This may affect trailer availability",
          onAccept: _ctx.checkCurrentNavigationTask,
          onReject: _ctx.hideCargoSensorIssueModal
        }, null, 8, ["onAccept", "onReject"]))
      : _createCommentVNode("", true),
    (
                _ctx.currentAttachedTrailers?.length > 0 &&
                _ctx.detachModalHidden === false
            )
      ? (_openBlock(), _createBlock(_component_AlreadyHaveTrailerAttached, {
          key: 4,
          attachedTrailers: _ctx.currentAttachedTrailers,
          promptStillNearTrailer: true,
          onOnDetach: _ctx.setupTrailerAttach,
          onOnSearchForTrailers: _ctx.hideTrailerAlreadyAttachedModal
        }, null, 8, ["attachedTrailers", "onOnDetach", "onOnSearchForTrailers"]))
      : _createCommentVNode("", true),
    (
                _ctx.showLoadedTrailerModal === true &&
                _ctx.trailerAssociationsEnabled === true
            )
      ? (_openBlock(), _createBlock(_component_DriverLoaded, {
          key: 5,
          attachedTrailerNumber: _ctx.loadedModalTrailerNumber,
          attachedTrailerCompany: _ctx.loadedModalTrailerCompany,
          showDeepLinkButton: true,
          fromReservation: _ctx.fromReservation,
          onOnSearchForTrailers: _ctx.hideModal,
          onHideModal: _ctx.hideModal
        }, null, 8, ["attachedTrailerNumber", "attachedTrailerCompany", "fromReservation", "onOnSearchForTrailers", "onHideModal"]))
      : _createCommentVNode("", true),
    (_ctx.verifyProximity)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_VerifyProximity, {
            trailer: _ctx.getTrailer,
            distance: _ctx.selectedResult.distance,
            onPlateOrVinVerified: _ctx.plateVinProximityVerifiedAttach,
            onQrScanVerified: _ctx.qrScanProximityVerifiedAttach,
            onOnCloseVerification: _cache[3] || (_cache[3] = ($event: any) => (_ctx.verifyProximity = false))
          }, null, 8, ["trailer", "distance", "onPlateOrVinVerified", "onQrScanVerified"])
        ]))
      : _createCommentVNode("", true)
  ]))
}